module.exports = __webpack_public_path__ + "img/about.133423b1.jpg";